<form data-testid="adx-booking-markup-info-form" class="template-form adx-booking-markup-info-form">
    <div data-testid="adx-booking-markup-info-main-div" class="filter__fields">
        <mat-card class="mat-elevation-z8">
            <mat-card-content>
                <mat-grid-list data-testid="adx-booking-markup-info-grid-list" [cols]="2" gutterSize="10px" rowHeight="90">
                    <mat-grid-tile data-testid="adx-booking-markup-info-markup-name-grid-tile">
                        <read-only-form-field title="Markup Name" testId="adx-booking-markup-info-markup-name" value="{{markupTypeMetadata?.markupName}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-markup-info-item-number-grid-tile">
                        <read-only-form-field title="Item Number" testId="adx-booking-markup-info-item-number" value="{{markupTypeMetadata?.itemNumber}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-markup-info-product-number-grid-tile">
                        <read-only-form-field title="Product Number" testId="adx-booking-markup-info-product-number" value="{{markupTypeMetadata?.productNumber}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-markup-info-product-category-grid-tile">
                        <read-only-form-field title="Product Category" testId="adx-booking-markup-info-product-category" value="{{markupTypeMetadata?.productCategory}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-markup-info-vendor-interface-id-grid-tile">
                        <read-only-form-field title="Vendor Interface Id" testId="adx-booking-markup-info-vendor-interface-id" value="{{markupTypeMetadata?.vendorInterfaceId}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-markup-info-provider-interface-id-grid-tile">
                        <read-only-form-field title="Provider Interface Id" testId="adx-booking-markup-info-provider-interface-id" value="{{markupTypeMetadata?.providerInterfaceId}}" />
                    </mat-grid-tile>
                </mat-grid-list>
            </mat-card-content>
        </mat-card>
    </div>
</form>
